import React from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";

import icon1 from '../../theme/assets/svg/lp_about_s4_icon1.svg';
import icon2 from '../../theme/assets/svg/lp_about_s4_icon2.svg';
import icon3 from '../../theme/assets/svg/lp_about_s4_icon3.svg';
import icon4 from '../../theme/assets/svg/lp_about_s4_icon4.svg';
import icon5 from '../../theme/assets/svg/lp_about_s4_icon5.svg';
import icon6 from '../../theme/assets/svg/lp_about_s4_icon6.svg';


const AboutS4 = () => {
    const { t } = useTranslation();

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('Наша')} <span>{t('цели')}</span></div>
                <div className={`${Styles.contentBox}`}>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemImgWrap}`}>
                            <img src={icon1} alt=""/>
                        </div>
                        <div className={`${Styles.contentBoxItemTitle}`}>{t('Запускаем сильные и устойчивые проекты')}</div>
                        <div className={`${Styles.contentBoxItemNote}`}>{t('Инициировать проекты, способные развиваться после IDO, а не терять динамику сразу после запуска.')}</div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemImgWrap}`}>
                            <img src={icon2} alt=""/>
                        </div>
                        <div className={`${Styles.contentBoxItemTitle}`}>{t('Строим доверие через прозрачность')}</div>
                        <div className={`${Styles.contentBoxItemNote}`}>{t('Создать прозрачную среду с чёткими правилами, механиками и сроками.')}</div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemImgWrap}`}>
                            <img src={icon3} alt=""/>
                        </div>
                        <div className={`${Styles.contentBoxItemTitle}`}>{t('Согласуем цели проектов и сообщества')}</div>
                        <div className={`${Styles.contentBoxItemNote}`}>{t('Согласовать интересы проектов и участников с первого дня.')}</div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemImgWrap}`}>
                            <img src={icon4} alt=""/>
                        </div>
                        <div className={`${Styles.contentBoxItemTitle}`}>{t('Защищаем наших участников')}</div>
                        <div className={`${Styles.contentBoxItemNote}`}>{t('Минимизировать риски для участников за счёт строгого отбора и прозрачных условий участия.')}</div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemImgWrap}`}>
                            <img src={icon5} alt=""/>
                        </div>
                        <div className={`${Styles.contentBoxItemTitle}`}>{t('Формируем долгосрочный подход')}</div>
                        <div className={`${Styles.contentBoxItemNote}`}>{t('Стимулировать долгосрочное участие вместо спекулятивного поведения.')}</div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemImgWrap}`}>
                            <img src={icon6} alt=""/>
                        </div>
                        <div className={`${Styles.contentBoxItemTitle}`}>{t('Создаём устойчивую экосистему')}</div>
                        <div className={`${Styles.contentBoxItemNote}`}>{t('Сформировать экосистему, в которой проекты, сообщества и платформа взаимно усиливают друг друга.')}</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutS4;




